import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface ActiveWorkFabProps {
  icon: LucideIcon;
  label: string;
  to: string;
  pathId: string;
}

export const ActiveWorkFab: React.FC<ActiveWorkFabProps> = ({
  icon: Icon,
  label,
  to,
  pathId,
}) => {
  const navigate = useNavigate();
  const circleId = `${pathId}-rim`;

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      aria-label={label}
      className="relative h-14 w-14 flex-shrink-0 rounded-full bg-gray-900 text-white
        flex items-center justify-center fab-glow"
    >
      <Icon size={20} className="relative z-[1]" />
      <svg
        viewBox="0 0 56 56"
        className="absolute inset-0 pointer-events-none overflow-visible"
        aria-hidden
      >
        <defs>
          <path
            id={circleId}
            d="M 28,28 m -22,0 a 22,22 0 1,1 44,0 a 22,22 0 1,1 -44,0"
          />
        </defs>
        <text
          fill="white"
          fontSize="6.5"
          fontWeight="700"
          letterSpacing="1.4"
          className="uppercase"
        >
          <textPath href={`#${circleId}`} startOffset="50%" textAnchor="middle">
            {label}
          </textPath>
        </text>
      </svg>
    </button>
  );
};
